/** Pipeline stage column order — matches Kylas pipeline configuration. */
export const LEAD_PIPELINE_STAGE_ORDER: Record<string, string[]> = {
  "Inbound Pipeline - 2025": [
    "MQL",
    "Non Contactable",
    "Demo Call Booked",
    "Product Selection",
    "Urgent Sourcing Raised",
    "Proposal Shared",
    "Porforma Invoice Shared",
    "Sample Order",
    "Proposal/Samples Under Review",
    "Won",
    "Closed Unqualified",
    "Reactivate",
  ],
  "Sales Lead Pipeline - Outbound": [
    "Lead",
    "Contacted",
    "Nurturing",
    "Demo Call",
    "Product Selection",
    "Proposal Sharing",
    "Reactivate",
    "Sample Sharing",
    "Qualified",
    "Closed Unqualified",
    "Closed Lost",
  ],
  "Sales Lead Pipeline - Inbound": [
    "MQL",
    "Non Contactable",
    "Demo Call",
    "Product Selection",
    "Proposal Sharing",
    "Reactivate",
    "Returnable Sample Sharing",
    "Paid Sample Ordered",
    "PI Shared, Awaiting Payment",
    "Qualified",
    "Closed Unqualified",
    "Closed Lost",
  ],
};

const normalizeStageName = (value: string) => value.trim().toLowerCase();

export const getPipelineStageOrder = (pipelineName: string): string[] | undefined => {
  const normalizedPipeline = pipelineName.trim().toLowerCase();
  const match = Object.entries(LEAD_PIPELINE_STAGE_ORDER).find(
    ([name]) => name.toLowerCase() === normalizedPipeline
  );
  return match?.[1];
};

export const resolveStageKey = (stageName: string, stageOrder?: string[]): string => {
  const normalized = normalizeStageName(stageName);
  if (!stageOrder) return stageName.trim() || "-";

  const matchedStage = stageOrder.find(
    (stage) => normalizeStageName(stage) === normalized
  );
  return matchedStage ?? (stageName.trim() || "-");
};

export const sortStagesForPipeline = (
  stagesInData: string[],
  stageOrder?: string[],
): string[] => {
  if (!stageOrder?.length) {
    return [...stagesInData].sort((a, b) => a.localeCompare(b));
  }

  const dataByNormalized = new Map(
    stagesInData.map((stage) => [normalizeStageName(stage), stage])
  );
  const orderedStages = stageOrder.map(
    (stage) => dataByNormalized.get(normalizeStageName(stage)) ?? stage
  );

  const orderedNormalized = new Set(stageOrder.map(normalizeStageName));
  const extraStages = stagesInData
    .filter((stage) => !orderedNormalized.has(normalizeStageName(stage)))
    .sort((a, b) => a.localeCompare(b));

  return [...orderedStages, ...extraStages];
};
